import { lazy } from "react";
import { BrowserRouter, Outlet, Route, Routes } from "react-router-dom";
import { Provider } from "./context";
import Layout from "./components/Layout";
import { RequireAuth, Empty } from "./components/common";
import { Home, BrandsDirectory, VenuePage, Guide } from "./pages/Public";
import RouteBoundary from "./components/RouteBoundary";

const BrandHome = lazy(() => import("./pages/BrandHome"));
const BrandWorkspace = lazy(() => import("./pages/BrandWorkspace"));
const EventDetail = lazy(() => import("./pages/EventDetail"));
const Login = lazy(() =>
  import("./pages/Account").then((m) => ({ default: m.Login })),
);
const MyEvents = lazy(() =>
  import("./pages/Account").then((m) => ({ default: m.MyEvents })),
);
const Notifications = lazy(() =>
  import("./pages/Account").then((m) => ({ default: m.Notifications })),
);
const Profile = lazy(() =>
  import("./pages/Account").then((m) => ({ default: m.Profile })),
);
const DevMailbox = lazy(() =>
  import("./pages/Account").then((m) => ({ default: m.DevMailbox })),
);
const HostDashboard = lazy(() =>
  import("./pages/Host").then((m) => ({ default: m.HostDashboard })),
);
const BrandSettings = lazy(() =>
  import("./pages/Host").then((m) => ({ default: m.BrandSettings })),
);
const EventEditor = lazy(() => import("./pages/EventEditor"));
const EventManage = lazy(() => import("./pages/EventManage"));
const Admin = lazy(() => import("./pages/Admin"));
const VenueReservationForm = lazy(() => import("./pages/VenueReservationForm"));
const VenueReservations = lazy(() => import("./pages/VenueReservations"));
export default function App() {
  return (
    <BrowserRouter>
      <Provider>
        <Routes>
          <Route element={<Layout />}>
            <Route
              element={
                <RouteBoundary>
                  <Outlet />
                </RouteBoundary>
              }
            >
              <Route index element={<Home />} />
              <Route path="brands" element={<BrandsDirectory />} />
              <Route path="b/:slug" element={<BrandHome />} />
              <Route
                path="host/brands/:id/workspace"
                element={
                  <RequireAuth>
                    <BrandWorkspace />
                  </RequireAuth>
                }
              />
              <Route path="brands/:id" element={<BrandHome />} />
              <Route path="events/:id" element={<EventDetail />} />
              <Route path="venue" element={<VenuePage />} />
              <Route
                path="venue/reservations/new"
                element={<VenueReservationForm />}
              />
              <Route
                path="me/venue-reservations"
                element={
                  <RequireAuth>
                    <VenueReservations />
                  </RequireAuth>
                }
              />
              <Route path="guide" element={<Guide />} />
              <Route path="login" element={<Login />} />
              <Route path="dev/mail" element={<DevMailbox />} />
              <Route
                path="me"
                element={
                  <RequireAuth>
                    <MyEvents />
                  </RequireAuth>
                }
              />
              <Route
                path="profile"
                element={
                  <RequireAuth>
                    <Profile />
                  </RequireAuth>
                }
              />
              <Route
                path="notifications"
                element={
                  <RequireAuth>
                    <Notifications />
                  </RequireAuth>
                }
              />
              <Route
                path="host"
                element={
                  <RequireAuth>
                    <HostDashboard />
                  </RequireAuth>
                }
              />
              <Route
                path="host/brands/new"
                element={
                  <RequireAuth>
                    <BrandSettings />
                  </RequireAuth>
                }
              />
              <Route
                path="host/brands/:id"
                element={
                  <RequireAuth>
                    <BrandSettings />
                  </RequireAuth>
                }
              />
              <Route
                path="host/events/new"
                element={
                  <RequireAuth>
                    <EventEditor />
                  </RequireAuth>
                }
              />
              <Route
                path="host/events/:id"
                element={
                  <RequireAuth>
                    <EventManage />
                  </RequireAuth>
                }
              />
              <Route
                path="host/events/:id/edit"
                element={
                  <RequireAuth>
                    <EventEditor />
                  </RequireAuth>
                }
              />
              <Route
                path="admin"
                element={
                  <RequireAuth admin>
                    <Admin />
                  </RequireAuth>
                }
              />
              <Route
                path="*"
                element={<Empty>ページが見つかりません / 页面不存在</Empty>}
              />
            </Route>
          </Route>
        </Routes>
      </Provider>
    </BrowserRouter>
  );
}
